var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodatafound"},[(_vm.viewData || _vm.mobileViewResponse)?_c('span',{staticClass:"empty-state-view"},[_vm._v(_vm._s(_vm.viewData))]):_c('span',{staticClass:"message"},[_vm._v("No Data Found!")])])}
var staticRenderFns = []

export { render, staticRenderFns }